<template>
    <router-link class="Logo" :to="homeRoute" :class="modifiers">
        <svg class="Logo-link">
            <use xlink:href="#logo"></use>
        </svg>
    </router-link>
</template>

<script>
import * as routes from '@/app/routes'
export default {
    name: 'Logo',
    props: {
        light: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        homeRoute() {
            return {
                name: routes.HOME,
            }
        },
        modifiers() {
            const { light } = this
            return {
                'Logo--light': light,
            }
        },
    },
}
</script>

<style src="styles/components/Logo.styl" lang="stylus"></style>


// WEBPACK FOOTER //
// src/app/components/Logo.vue